import React from "react";
import TimelineItem from "@material-ui/lab/TimelineItem";
import TimelineSeparator from "@material-ui/lab/TimelineSeparator";
import TimelineConnector from "@material-ui/lab/TimelineConnector";
import TimelineContent from "@material-ui/lab/TimelineContent";
import TimelineDot from "@material-ui/lab/TimelineDot";
import ReceiptOutlinedIcon from "@material-ui/icons/ReceiptOutlined";

const TopTimeLineItem = ({ children }) => (
  <TimelineItem>
    <TimelineSeparator>
      <TimelineDot color="primary">
        <ReceiptOutlinedIcon />
      </TimelineDot>
      <TimelineConnector />
    </TimelineSeparator>
    <TimelineContent>{children}</TimelineContent>
  </TimelineItem>
);

export default TopTimeLineItem;
